export const fetchClientIp = async () => {
  if (!window.fetch) return '';

  const ip = await window
    .fetch('/api/get-ip')
    .then(res => res.json())
    .then(res => (res.code === 0 ? res.data.ip : ''))
    .catch(() => '');

  return ip;
};
